import type { AxiosInstance } from 'axios';
import type { ApiPaginationResponse } from '@/types';
import type { ExchangeRateReponse } from '@/types/api/record.type';

export default function recordApi(ai: AxiosInstance) {
  function getExchangeRates<D extends ExchangeRateReponse, R extends ApiPaginationResponse<D>>() {
    return ai.get<R>('/finance/getExchangeRates');
  }

  return {
    getExchangeRates
  };
}